import { Box, Grid, Link, Typography } from '@mui/material'
import React from 'react'
import Startup from '../../../../models/startup'

interface Props {
  startup: Startup
}

const StartupInfoSection = (props: Props) => {
  const gridItem = (key: string, value: string, link: string | undefined) => {
    return (
      <Grid item xs={6}>
        <Box display='flex' flexDirection='column' alignItems='flex-start'>
          <Typography variant='caption' sx={{ padding: '32px 0px 16px 0px' }}>
            {key}
          </Typography>
          {link !== undefined &&
            <Link href={link} target='_blank'>
              <Typography variant='body1' color='#596379'>
                {value}
              </Typography>
            </Link>
          }
          {link === undefined &&
            <Typography variant='body1' color='#596379'>
              {value}
            </Typography>
          }
        </Box>
      </Grid>
    )
  }

  return (
    <Box sx={{
      border: 1,
      borderColor: 'text.secondary',
      borderRadius: '16px',
      backgroundColor: '#fff',
      padding: '24px'
    }}
    display='flex'
    flexDirection='column'
    >
      <Typography variant='h5'>
        {props.startup.name}
      </Typography>
      <Box display='flex' flexDirection='column' alignItems='flex-start'>
        <Typography variant='caption' sx={{ padding: '32px 0px 16px 0px' }}>
          DESCRIPTION
        </Typography>
        <Typography variant='body1' color='#596379'>
          {props.startup.description}
        </Typography>
      </Box>
      <Grid container spacing={0}>
        {gridItem('Point of contact', props.startup.contactName || '-', undefined)}

        {gridItem('Website', props.startup.companyWebsite || '-', props.startup.companyWebsite || undefined)}

        {
          gridItem(
            'Contact Email', 
            props.startup.contactEmail || '-', 
            props.startup.contactEmail ? `mailto:${props.startup.contactEmail}` : undefined
          )
        }

        {gridItem('Phone', props.startup.companyPhone || '-', undefined)}
      </Grid>
    </Box>
  )
}

export default StartupInfoSection
